<script setup lang="ts">
import ButtonThemeLocal from '@/components/main/ButtonThemeLocal.vue'
import SpinerLoader from '@/components/main/SpinerLoader.vue'
import { dataLoaded } from '@/event/dataLoaded'
import { productBus } from '@/event/product/productBus'
import { theme } from '@/event/theme/theme'
import ModalProductHappy from '@/happyTheme/components/product/ModalProductHappy.vue'
import { showSelectedModalProductHappy } from '@/happyTheme/event/product/showSelectedModalProductHappy'
import { toggleSelectedModalProductHappy } from '@/happyTheme/utils/product/toggleSelectedModalProductHappy'
import { defineAsyncComponent } from 'vue'
const Error = defineAsyncComponent(() => import('@/components/error/Error.vue'))
</script>

<template>
    <section class="w-full flex justify-center relative">
        <ModalProductHappy v-if="theme === 'happy-light' || theme === 'happy-dark'" />

        <ButtonThemeLocal />

        <RouterView v-if="dataLoaded == 2" class="router-view-class" />

        <Error v-else-if="dataLoaded == 1" />
        <SpinerLoader v-else />
    </section>
</template>

<style scoped>
.router-view-class {
    @apply min-w-full;
}

.overlay-section-product-happy {
    @apply fixed top-0 w-screen h-screen transition-opacity duration-300 bg-text-dark-happy-light opacity-70;
}

@media screen and (min-width: 1030px) {
    .router-view-class {
        @apply min-w-[60rem] w-[61rem];
    }
}

@media screen and (min-width: 1280px) {
    .router-view-class {
        @apply min-w-[65rem] w-[66rem];
    }
}

@media screen and (min-width: 1500px) {
    .router-view-class {
        @apply min-w-[75rem] w-[75rem];
    }
}

@media screen and (min-width: 2000px) {
    .router-view-class {
        @apply min-w-[80rem] w-[80rem];
    }
}
</style>
